module.exports = "<h1>RESERVATIONS</h1>\r\n<button type=\"button\" class=\"btn btn-default btn-lg\" routerLink=\"/reservations/new\">\r\n    <span class=\"glyphicon glyphicon-plus\" aria-hidden=\"true\"></span> Toevoegen\r\n  </button>\r\n\r\n  <button type=\"button\" class=\"btn btn-default btn-lg\">\r\n    <span class=\"glyphicon glyphicon-search\" aria-hidden=\"true\"></span> Opzoeken\r\n  </button>"


//////////////////
// WEBPACK FOOTER
// C:/Users/krist/source/repos/FoodButtler.App/src/app/pages/reservations/reservations.component.html
// module id = ../../../../../src/app/pages/reservations/reservations.component.html
// module chunks = main